import BookIndex from "components/shared/book/list";
import SharedReactTable from "components/shared/reactTable";
import { dateTimeToView } from "helpers/date";
import { paths } from "helpers/paths";
import { DateColumnFilter, rowIndexColumn } from "helpers/reactTable";
import { tableContainer } from "helpers/redux";
import React from "react";
import { Link } from "react-router-dom";

export class News extends BookIndex {
    get tableColumns() {
        return [
            rowIndexColumn,
            { Header: "ID", accessor: "id", width: 100, filterable: true, filterType: "int" },
            {
                Header: "Название",
                accessor: "header",
                filterable: true,
                sortable: true,
                Cell: ({ value, row: { original } }) => {
                    const { id } = original;
                    return <Link to={paths.newsShow(id)}>{value}</Link>;
                },
            },
            {
                Header: "Автор",
                accessor: "createdBy",
                sortable: false,
                Cell: ({ value }) => (value ? value.shortName : ""),
            },
            {
                Header: "Дата создания",
                accessor: "createdAt",
                filterable: true,
                filterType: "date",
                sortable: true,
                Filter: DateColumnFilter,
                Cell: ({ value }) => dateTimeToView(value),
                CSVExport: ({ value }) => dateTimeToView(value),
            },
            {
                Header: "Дата редактирования",
                accessor: "updatedAt",
                filterable: true,
                filterType: "date",
                sortable: true,
                Filter: DateColumnFilter,
                Cell: ({ value }) => dateTimeToView(value),
                CSVExport: ({ value }) => dateTimeToView(value),
            },
        ];
    }

    renderHead = () => {
        return (
            <div className="book-list__head-wrap">
                <div className="book-list__head">
                    <div className="book-list__head-close close close--sm" onClick={this.close} />
                    <div className="book-list__head-title">
                        {this.props.title}
                        {this.renderCounter()}
                    </div>
                    <div className="btn-toolbar">{this.renderCreateButton()}</div>
                </div>
            </div>
        );
    };

    renderListComponent = () => {
        return <SharedReactTable {...this.props} columns={this.state.tableColumns} />;
    };
}

export default tableContainer(News, "news");
